import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { UnsupportedBrowserPage } from '../components/app/UnsupportedBrowserPage';
import { Config } from '../services/Config';

export const Route = createFileRoute('/unsupported-browser')({
  staticData: {
    secure: false,
  },
  component: UnsupportedBrowserRoute,
});

function UnsupportedBrowserRoute() {
  return (
    <UnsupportedBrowserPage appName={`${Config.APPLICATION_DISPLAY_NAME}`} />
  );
}
